import {
  call,
  put,
  takeLatest,
  takeEvery
} from "redux-saga/effects";
import {
  uploadFile
} from "utils/api";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

import {
  defaultReturn,
  makePayload,
  generateDefaultActions,
  subKeySaga,
  requestSaga,
  fillDictionary
} from "../utils/helpers";

const initialState = {
  hedgeByStatus: [],
  hedgeDetail: {},
  hedgeNotes: [],
  hedgeFiles: [],
  hedgesOfLoan: [],
  hedgesOfLoanId: null
};

export default function hedgeReducer(state = initialState, action) {
  const { type, payload, subKey } = action;
  switch (type) {
    case SET_PREF_HEDGE_OF_LOAN.success:
      return state;
    case GET_HEDGES_OF_LOAN.success:
      return { ...state, hedgesOfLoan: payload.result, hedgesOfLoanId: payload.loanId };
    case GET_HEDGE_BY_DEALID_AND_STATUS.success:
      return fillDictionary(state, payload, "hedgeByStatus", subKey);

    case GET_HEDGE.success:
      return defaultReturn(state, payload.data, "hedgeDetail");

    case UPDATE_HEDGE.success:
      ToastSuccess("Save Successful");

      return defaultReturn(state, payload.data, "hedgeDetail");

    case UPDATE_HEDGE_ESCROW.success:
      ToastSuccess("Save Successful");

      return defaultReturn(state, payload.data, "hedgeDetail");

    case GET_HEDGE_NOTES.success:
    case DELETE_NOTE.success:
      return fillDictionary(state, payload.data, "hedgeNotes", subKey);

    case GET_HEDGE_FILES.success:
      return fillDictionary(state, payload.data, "hedgeFiles", subKey);

    default:
      return state;
  }
}

export function* hedgeSaga() {
  yield takeEvery(DELETE_HEDGE.value, deleteHedgeSaga);
  yield takeEvery(GET_HEDGE_BY_DEALID_AND_STATUS.value, getHedgeByDealIdAndStatusSaga);
  yield takeLatest(GET_HEDGE.value, getHedgeSaga);
  yield takeLatest(UPDATE_HEDGE.value, updateHedgeDetailsSaga);
  yield takeLatest(UPDATE_HEDGE_ESCROW.value, hedgeUpdateHedgeEscrowSaga);

  yield takeLatest(GET_HEDGE_NOTES.value, getHedgeNotesSaga);
  yield takeLatest(ADD_NOTE_TO_HEDGE.value, addNoteToHedgeSaga);
  yield takeLatest(DELETE_NOTE.value, deleteNoteSaga);

  yield takeLatest(GET_HEDGE_FILES.value, getHedgeFilesSaga);
  yield takeLatest(ADD_FILE_TO_HEDGE.value, addFileToHedgeSaga);
  yield takeLatest(DELETE_HEDGE_FILE.value, deleteHedgeFileSaga);

  yield takeLatest(GET_HEDGES_OF_LOAN.value, getHedgesOfLoanSaga);
  yield takeEvery(SET_PREF_HEDGE_OF_LOAN.value, setPrefHedgeOfLoanSaga);
}

// GET_HEDGE_BY_DEALID_AND_STATUS
export const GET_HEDGE_BY_DEALID_AND_STATUS = generateDefaultActions("GET_HEDGE_BY_DEALID_AND_STATUS");
export const getHedgeByDealIdAndStatus = payload => makePayload(GET_HEDGE_BY_DEALID_AND_STATUS.value, payload);
function* getHedgeByDealIdAndStatusSaga(payload) {
  const url = `/getHedgesByDealId/${payload.dealId}/${payload.hedgeStatus}`;
  const requestSaga = subKeySaga(payload.hedgeStatus);
  yield requestSaga(GET_HEDGE_BY_DEALID_AND_STATUS, url);
}

export const GET_HEDGES_OF_LOAN = generateDefaultActions("GET_HEDGES_OF_LOAN");
export const getHedgesOfLoan = payload => makePayload(GET_HEDGES_OF_LOAN.value, payload);
function* getHedgesOfLoanSaga(payload) {
  const url = "/getHedgesOfLoan";
  yield requestSaga(GET_HEDGES_OF_LOAN, url, "POST", payload);
}

export const SET_PREF_HEDGE_OF_LOAN = generateDefaultActions("SET_PREF_HEDGE_OF_LOAN");
export const setPrefHedgeOfLoan = payload => makePayload(SET_PREF_HEDGE_OF_LOAN.value, payload);
function* setPrefHedgeOfLoanSaga(payload) {
  const url = "/setPrefHedgeOfLoan";
  yield requestSaga(SET_PREF_HEDGE_OF_LOAN, url, "POST", payload);
}

export const DELETE_HEDGE = generateDefaultActions("DELETE_HEDGE");
export const deleteHedge = payload => makePayload(DELETE_HEDGE.value, payload);
function* deleteHedgeSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;

  const url = "/deleteHedge";
  yield requestSaga(DELETE_HEDGE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

// GET_HEDGE
export const GET_HEDGE = generateDefaultActions("GET_HEDGE");
export const getHedge = payload => makePayload(GET_HEDGE.value, payload);
function* getHedgeSaga(payload) {
  let url = "/hedge";
  if (payload.hedgeId) {
    url = `${url}?id=${payload.hedgeId}&dealId=${payload.dealId}`;
  }

  const requestSaga = subKeySaga(payload.hedgeStatus);
  yield requestSaga(GET_HEDGE, url);
}

// UPDATE_HEDGE
export const UPDATE_HEDGE = generateDefaultActions("UPDATE_HEDGE");
export const updateHedgeDetails = payload => makePayload(UPDATE_HEDGE.value, payload);
function* updateHedgeDetailsSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;

  const url = "/hedge";
  const requestSaga = subKeySaga(payload.hedgeStatus);
  yield requestSaga(UPDATE_HEDGE, url, "POST", payload);
  if (callback) {
    callback();
  }
}

/*
 * UPDATE_HEDGE_ESCROW
 * payload: { isNew: true, hedge }
 */
export const UPDATE_HEDGE_ESCROW = generateDefaultActions("UPDATE_HEDGE_ESCROW");
export const hedgeUpdateHedgeEscrow = payload => makePayload(UPDATE_HEDGE_ESCROW.value, payload);
function* hedgeUpdateHedgeEscrowSaga(payload) {
  const callback = payload.callback;
  delete payload.callback;

  const url = "/hedge/escrow";
  const requestSaga = subKeySaga(payload.hedgeStatus);
  yield requestSaga(UPDATE_HEDGE_ESCROW, url, "POST", payload);
  if (callback) {
    callback();
  }
}

/*
 * NOTES
 * GET_HEDGE_NOTES
 */
export const GET_HEDGE_NOTES = generateDefaultActions("GET_HEDGE_NOTES");
export const getHedgeNotes = payload => makePayload(GET_HEDGE_NOTES.value, payload);
function* getHedgeNotesSaga(payload) {
  const url = `/hedge/notes/${payload.modelId}`;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_HEDGE_NOTES, url, "GET");
}
// ADD_NOTE_TO_HEDGE
export const ADD_NOTE_TO_HEDGE = generateDefaultActions("ADD_NOTE_TO_HEDGE");
export const addNoteToHedge = (model, modelId, note) => ({ type: ADD_NOTE_TO_HEDGE.value, model, modelId, note, url: "/notes" });
function* addNoteToHedgeSaga(payload) {
  const url = "/hedge/addnote";
  const note = {
    model: "hedge",
    modelId: payload.modelId,
    note: payload.note,
    pinned: false
  };

  yield requestSaga(ADD_NOTE_TO_HEDGE, url, "POST", {
    note
  });
  ToastSuccess("Note Added Successfully");
  yield getHedgeNotesSaga({
    modelName: "hedge",
    modelId: payload.modelId,
    subKey: payload.modelId
  });
}
// DELETE_NOTE
export const DELETE_NOTE = generateDefaultActions("DELETE_NOTE");
export const deleteNote = payload => makePayload(DELETE_NOTE.value, payload);
function* deleteNoteSaga(payload) {
  const {
    noteId,
    modelName,
    modelId
  } = payload;
  try {
    const url = `/notes/${noteId}?modelName=${modelName}&modelId=${modelId}`;
    const requestSaga = subKeySaga(payload.subKey);
    yield requestSaga(DELETE_NOTE, url, "DELETE");
    ToastSuccess("Note Deleted");
  } catch (error) {
    ToastError(`Deleting Note Failed: ${error.message}`);
  }
}

/*
 * ATACHMENTS
 *  GET_HEDGE_FILES
 */
export const GET_HEDGE_FILES = generateDefaultActions("GET_HEDGE_FILES");
export const getHedgeFiles = payload => makePayload(GET_HEDGE_FILES.value, payload);
function* getHedgeFilesSaga(payload) {
  const url = "/getFiles/byModel";
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_HEDGE_FILES, url, "POST", payload);
}
// ADD_FILE_TO_HEDGE
export const ADD_FILE_TO_HEDGE = generateDefaultActions("ADD_FILE_TO_HEDGE");
export const addFileToHedge = (model, modelId, file) => ({ type: ADD_FILE_TO_HEDGE.value, model, modelId, file, url: "/files" });
function* addFileToHedgeSaga(payload) {
  try {
    const response = yield call(uploadFile, payload);
    yield put(ADD_FILE_TO_HEDGE.createSuccess(response));
    ToastSuccess("File Uploaded Successfully");
    yield getHedgeFilesSaga({
      modelName: "hedge",
      modelId: payload.modelId,
      subKey: payload.modelId
    });
  } catch (error) {
    yield put(ADD_FILE_TO_HEDGE.createFailure(error));
    ToastError(`Upload Failed: ${error.message}`);
  }
}
// DELETE_HEDGE_FILE
export const DELETE_HEDGE_FILE = generateDefaultActions("DELETE_HEDGE_FILE");
export const deleteHedgeFile = payload => makePayload(DELETE_HEDGE_FILE.value, payload);
function* deleteHedgeFileSaga(payload) {
  const url = `/files/${payload.fileId}`;
  yield requestSaga(DELETE_HEDGE_FILE, url, "DELETE");
  if (payload.shouldUpdateAfter) {
    yield getHedgeFilesSaga({
      modelId: payload.modelId,
      modelName: payload.modelName,
      subKey: payload.subKey
    });
  }
}
